<template>
  <section id="admin-customer-edit" class="admin-page-mobile">
    <b-card>
      <b-card-header><h2>ویرایش مشخصات مشتری</h2>
      </b-card-header>
      <b-card-body>
        <b-form @submit.prevent>
          <b-row>
            <!-- name -->
            <b-col cols="6">
              <b-form-group
                label="موبایل"
                label-for="vi-mobile"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-mobile"
                    v-model="customer.mobile"
                    placeholder=""
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>

            <!-- name -->
            <b-col cols="6">
              <b-form-group
                label="نام"
                label-for="vi-name"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-name"
                    v-model="customer.name"
                    placeholder=""
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- پروتکل -->
            <b-col cols="6">
              <b-form-group
                label="نام خانوادگی"
                label-for="vi-family"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="UserIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="vi-name"
                    v-model="customer.family"
                    placeholder=""
                  />
                </b-input-group>
              </b-form-group>
            </b-col>

            <!-- reset and submit -->
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click="submitForm()"
              >
                ذخیره
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                class="mr-1"
                variant="outline-primary"
                @click.prevent="onCancel"
              >
                لغو
              </b-button>

            </b-col>
          </b-row>
        </b-form>

      </b-card-body>
    </b-card>
    <b-card>
      <b-card-body>
        <b-button
          size="sm"
          class="mr-1"
          variant="outline-primary"
          @click="addDeviceClick()"
        >
          <feather-icon
            icon="PlusIcon"
            size="22"
            class="align-text-top"
          />
          افزودن ردیاب
        </b-button>

        <b-button
          size="sm"
          class="mr-1"
          variant="outline-primary"
          @click="assignDeviceClick()"
        >
          <v-icon
            size="22"
            style="color:#296bbf"
          >
            mdi-car-arrow-left
          </v-icon>
          اختصاص ردیاب
        </b-button>

        <v-data-table
          :headers="headers"
          :items="desserts"
          mobile-breakpoint="0"
        >

          <template v-slot:item.actions="{ item }">
            <v-icon
              style="color:rgb(32, 213, 255)"
              title="ویرایش"
              @click="editDeviceClick(item)"
            >
              mdi-border-color
            </v-icon>
            <v-icon
              style="color:rgb(137, 41, 191)"
              title="ارسال تنظیمات"
              @click="onConfigure(item)"
            >
              mdi-android-messages
            </v-icon>
            <v-icon
              style="color:#296bbf"
              title="انتقال به کاربر دیگر"
              @click="onEditItem('modal-change-user',item)"
            >
              mdi-account-switch-outline
            </v-icon>
            <v-icon
              style="color:rgb(191, 41, 55)"
              title="تغییر نماینده"
              @click="onEditItem('modal-change-reseller',item)"
            >
              mdi-account-tie-hat
            </v-icon>
            <v-icon
              style="color:rgb(88, 191, 41)"
              title="تغییر مدل"
              @click="onEditItem('modal-change-model',item)"
            >
              mdi-usb-flash-drive
            </v-icon>
            <v-icon
              style="color:rgb(202, 128, 32)"
              title="تغییر سیمکارت"
              @click="onEditItem('modal-change-sim',item)"
            >
              mdi-sim-outline
            </v-icon>
            <v-icon
              style="color:rgb(138, 131, 131)"
              title="حذف"
              @click="onDeleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn
              variant="gradient-primary"
              @click="getAllDevices"
            >
              بروزرسانی
            </v-btn>
          </template>
        </v-data-table>
      </b-card-body>

      <!-- modal login-->
      <b-modal
        id="modal-addDevice"
        ref="modal-addDevice"
        cancel-variant="outline-secondary"
        ok-title="افزودن"
        cancel-title="بستن"
        centered
        title="اطلاعات ردیاب"
      >
        <b-form>
          <b-form-group
            label="IMEI"
            label-for="v-imei"
          >
            <b-form-input
              id="vi-imei"
              v-model="device.imei"
              placeholder=""
              required
            />
          </b-form-group>
          <b-form-group
            label="شماره سیمکارت"
            label-for="v-imei"
          >
            <b-form-input
              id="vi-sim"
              v-model="device.sim"
              placeholder=""
              required
            />
          </b-form-group>
          <b-form-group
            label="عنوان خودرو"
            label-for="v-title"
          >
            <b-form-input
              id="vi-title"
              v-model="device.title"
              placeholder=""
              required
            />
          </b-form-group>
          <b-form-group
            label="مدل"
            label-for="v-model"
          >
            <b-form-select
              id="vi-model"
              v-model="device.modelId"
              required
            >
              <option
                selected
                disabled
                value=""
              >
                انتخاب کنید
              </option>
              <option
                v-for="item in options"
                :value="item._id"
              >
                {{ item.title }} - {{ item.protocol }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="نمایندگی"
            label-for="v-mobile"
          >
            <b-form-select
              v-model="device.resellerId"
              required
            >
              <option
                selected
                disabled
                value=""
              >
                انتخاب کنید
              </option>
              <option
                v-for="item in agentList"
                :value="item._id"
              >
                {{ item.name }} {{ item.family }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="سرور"
            label-for="v-name"
          >
            <b-form-select
              v-model="device.serverId"
              required
            >
              <option
                selected
                disabled
                value=""
              >
                انتخاب کنید
              </option>
              <option
                v-for="item in serverList"
                :value="item._id"
              >
                {{ item.title }} {{ item.url }}:{{ item.port }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group>
            <b-col md="12">
              <b-form-group
                label="نوع وسیله نقلیه"
                label-for="v-address"
              >
                <b-form-select
                  v-model="device.category"
                  :options="carOptions"
                  :select-size="6"
                />
              </b-form-group>
            </b-col>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox
              id="disabled"
              v-model="device.disabled"
              name="disabled"
              value="true"
            >
              غیرفعال
            </b-form-checkbox>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-addDevice')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalAddDevice()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>

      <!-- modal login-->
      <b-modal
        id="modal-assignDevice"
        ref="modal-assignDevice"
        cancel-variant="outline-secondary"
        ok-title="افزودن"
        cancel-title="بستن"
        centered
        title="اختصاص ردیاب به کاربر"
      >
        <b-form>
          <b-form-group
            label="IMEI"
            label-for="v-imei"
          >
            <b-form-select
              v-model="device.imei"
              required
            >
              <option
                v-for="item in freeDevices"
                :value="item._Id"
              >
                {{ item.imei }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="شماره سیمکارت"
            label-for="v-imei"
          >
            <b-form-input
              id="vi-sim"
              v-model="device.sim"
              placeholder=""
              required
            />
          </b-form-group>
          <b-form-group
            label="عنوان خودرو"
            label-for="v-title"
          >
            <b-form-input
              id="vi-title"
              v-model="device.title"
              placeholder=""
              required
            />
          </b-form-group>
          <b-form-group>
            <b-col md="12">
              <b-form-group
                label="نوع وسیله نقلیه"
                label-for="v-address"
              >
                <b-form-select
                  v-model="device.category"
                  :options="carOptions"
                  :select-size="6"
                />
              </b-form-group>
            </b-col>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox
              id="disabled"
              v-model="device.disabled"
              name="disabled"
              value="true"
            >
              غیرفعال
            </b-form-checkbox>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-assignDevice')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalAddDevice()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>

      <!-- modal change user -->
      <b-modal
        id="modal-change-user"
        ref="modal-change-user"
        cancel-variant="outline-secondary"
        ok-title="ذخیره"
        cancel-title="بستن"
        centered
        title="انتقال دستگاه به کاربر جدید"
      >

        <b-form>
          <!-- title -->
          <b-form-group
            label="کاربر فعلی"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="device.userId"
                required
                disabled
              >
                <option
                  v-for="item in userList"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="کاربر جدید"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="userIdSelected"
                required
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in userList"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-user')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeUser()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>
      <!-- modal change reseller -->
      <b-modal
        id="modal-change-reseller"
        ref="modal-change-reseller"
        cancel-variant="outline-secondary"
        ok-title="ذخیره"
        cancel-title="بستن"
        centered
        title="انتقال دستگاه به نماینده جدید"
      >

        <b-form>
          <!-- title -->
          <b-form-group
            label="نماینده فعلی"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="device.resellerId"
                required
                disabled
              >
                <option
                  v-for="item in agentList"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>

          <b-form-group
            label="نماینده جدید"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="resellerIdSelected"
                required
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in agentList"
                  :value="item._id"
                >
                  {{ item.name }} {{ item.family }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-reseller')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeReseller()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>

      <!-- modal change reseller -->
      <b-modal
        id="modal-change-model"
        ref="modal-change-model"
        cancel-variant="outline-secondary"
        ok-title="ذخیره"
        cancel-title="بستن"
        centered
        title="تغییر مدل دستگاه"
      >

        <b-form>
          <!-- title -->
          <b-form-group
            label="مدل فعلی"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="device.modelId"
                required
                disabled
              >
                <option
                  v-for="item in options"
                  :value="item._id"
                >
                  {{ item.title }} - {{ item.protocol }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label="مدل جدید"
            label-for="vi-imei"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="UserIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="modelIdSelected"
                required
              >
                <option
                  selected
                  disabled
                  value=""
                >
                  انتخاب کنید
                </option>
                <option
                  v-for="item in options"
                  :value="item._id"
                >
                  {{ item.title }} - {{ item.protocol }}
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-model')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeModel()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>
      <!-- modal change reseller -->
      <b-modal
        id="modal-change-sim"
        ref="modal-change-sim"
        cancel-variant="outline-secondary"
        ok-title="ذخیره"
        cancel-title="بستن"
        centered
        title="تغییر سیمکارت دستگاه"
      >

        <b-form>
          <b-form-group
            label="شماره سیمکارت فعلی"
            label-for="v-Sim"
          >
            <b-form-input
              id="v-Sim"
              v-model="device.sim"
              class="numeric-input"
              maxlength="11"
              disabled
            />
          </b-form-group>
          <b-form-group
            label="شماره سیمکارت جدید"
            label-for="v-Sim"
          >
            <b-form-input
              id="v-Sim"
              v-model="simIdSelected"
              placeholder="09xxxxxxxxx"
              maxlength="11"
              class="numeric-input"
            />
          </b-form-group>
        </b-form>
        <template #modal-footer="">
          <b-button
            size="sm"
            variant="danger"
            @click="$bvModal.hide('modal-change-sim')"
          >
            بستن
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="modalChangeModel()"
          >
            ذخیره
          </b-button>
        </template>
      </b-modal>

    </b-card>
  </section>
</template>

<script>

import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend, BCard, BCardBody, BCardHeader,
  BFormSelect, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import router from '@/router'
import Customer from '@/models/customer'
import Config from '../../../../config'
import Model from '@/models/model'
import Device from '@/models/device'
import ModelService from '@/services/model.service'
import customerService from '@/services/customer.service'
import ServerService from '@/services/server.service'
// eslint-disable-next-line import/no-named-as-default
import DeviceService from '@/services/device.service'

export default {
  components: {
    BFormSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selectedCategory: '0',
      carOptions: Config.carTypes,
      desserts: [],
      customer: new Customer('', '', '', '', '', ''),
      options: [],
      freeDevices: [],
      userList: [],
      agentList: [],
      serverList: [],
      user_id: '',
      model: new Model('', '', '', ''),
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      userIdSelected: '',
      resellerIdSelected: '',
      modelIdSelected: '',
      simIdSelected: '',
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'دسته',
          align: 'start',
          sortable: false,
          value: 'categoryName',
        },
        {
          text: 'عنوان',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: 'نمایندگی', value: 'resellerName' },
        { text: 'مدل', value: 'model' },
        { text: 'سیمکارت', value: 'sim' },
        { text: 'imei', value: 'imei' },
        { text: 'وضعیت', value: 'status' },
        { text: 'تاریخ ایجاد', value: 'creationDate' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async mounted() {
    try {
      ModelService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.options = res.result.data
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
    try {
      this.agentList = []
      await customerService.getAll({ type: 1 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                this.agentList.push(res.result.data[i])
              }
            }
          }
        },
      )
      await customerService.getAll({ type: 2 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                this.agentList.push(res.result.data[i])
              }
            }
          }
        },
      )
      this.userList = []
      await customerService.getAll({ type: -1 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.userList = res.result.data
            }
          }
        },
      )
      // console.log(this.agentList)
    } catch (err) {
      // console.log(err)
    }
    try {
      ServerService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.serverList = res.result.data
            } else {
              this.serverList = []
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
  },
  created() {
    if ('id' in this.$route.params) {
      this.getContactById()
      this.getAllDevices()
    } else {
      router.push({ name: 'admin-customer-list' })
    }
  },
  methods: {
    modalAddDevice() {
      this.device.disabled = this.disabled === 'true'
      DeviceService.addToUser(this.device)
        .then(
          res => {
            // console.log(res)
            if (res.status === 'success') {
              // router.push({ name: 'admin-device-all' })
              this.$refs['modal-addDevice'].hide()
              this.getAllDevices()
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'add device error',
                  text: res.message,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
    },
    getAllDevices() {
      DeviceService.getAllByUserId({ id: this.user_id }).then(
        res => {
          if (res.status === 'success') {
            this.desserts = []
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                const temp = res.result.data[i]
                temp.model = temp.modelId.title
                temp.status = temp.disabled ? 'غیرفعال' : 'فعال'
                temp.userName = temp.userId !== undefined ? `${temp.userId.name} ${temp.userId.family}` : ''
                temp.resellerName = `${temp.resellerId.name} ${temp.resellerId.family}`
                temp.categoryName = ''
                for (let j = 0; j <= Config.carTypes.length - 1; j += 1) {
                  const carType = Config.carTypes[j]
                  if (carType.value === temp.category) {
                    temp.categoryName = Config.carTypes[temp.category].text
                    break
                  }
                }
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                this.desserts.push(temp)
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    getContactById() {
      this.user_id = this.$route.params.id
      customerService.getById({ id: this.$route.params.id }).then(
        res => {
          if (res.status === 'success') {
            this.customer = res.result.data
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    async submitForm() {
      customerService.edit(this.customer).then(
        res => {
          if (res.status === 'success') {
            router.push({ name: 'admin-customer-list' })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'admin-customer-list' })
    },

    modalChangeUser() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeUser({ imei: parseInt(this.device.imei), resellerId: this.device.resellerId, customerId: this.userIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-change-user')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeReseller() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeUser({ imei: parseInt(this.device.imei), customerId: this.device.userId, resellerId: this.resellerIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-change-reseller')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeModel() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeModel({ imei: parseInt(this.device.imei), modelId: this.device.modelId, sim: this.simIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-change-model')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeSim() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeModel({ imei: parseInt(this.device.imei), sim: this.device.sim, modelId: this.modelIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.getAllDevices()
            this.$bvModal.hide('modal-change-sim')
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        DeviceService.delete({
          // eslint-disable-next-line no-underscore-dangle
          imei: this.desserts[index]._id,
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: res.result,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
      // Todo: Make this delete item from store
      // eslint-disable-next-line no-underscore-dangle
    },
    onEditItem(select, item) {
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      this.device._id = this.desserts[index]._id.toString()
      this.device.userId = this.desserts[index].userId._id.toString()
      this.device.imei = this.desserts[index].imei
      this.device.modelId = this.desserts[index].modelId._id.toString()
      this.device.resellerId = this.desserts[index].resellerId._id.toString()
      this.device.serverId = this.desserts[index].serverId._id.toString()
      this.device.disabled = this.desserts[index].disabled.toString()
      this.device.sim = this.desserts[index].sim.toString()

      this.$refs[select].show()
    },
    onConfigure(item) {
      const index = this.desserts.indexOf(item)
      this.device.imei = this.desserts[index].imei
      this.device.sim = this.desserts[index].sim.toString()

      if (this.device.imei && this.device.sim) {
        DeviceService.configure(this.device)
          .then(
            res => {
              if (res.status === 'error') {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'خطای تنظیم سیمکارت',
                    text: res.message,
                    icon: 'XIcon',
                    variant: 'danger',
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'دستگاه با موفقیت تنظیم شد.',
                    icon: 'EditIcon',
                    variant: 'success',
                  },
                })
              }
            },
          )
      }
    },
    addDeviceClick() {
      this.device = {}

      this.device.uid = this.user_id
      this.$refs['modal-addDevice'].show()
    },
    editDeviceClick(item) {
      this.device = {}
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      this.device._id = this.desserts[index]._id.toString()
      this.device.uid = this.desserts[index].userId._id.toString()
      this.device.imei = this.desserts[index].imei
      // eslint-disable-next-line no-underscore-dangle
      this.device.modelId = this.desserts[index].modelId._id.toString()
      // eslint-disable-next-line no-underscore-dangle
      this.device.resellerId = this.desserts[index].resellerId._id.toString()
      // eslint-disable-next-line no-underscore-dangle
      this.device.serverId = this.desserts[index].serverId._id.toString()
      this.device.disabled = this.desserts[index].disabled.toString()
      this.device.sim = this.desserts[index].sim.toString()
      this.device.title = this.desserts[index].title.toString()
      this.device.category = this.desserts[index].category

      this.$refs['modal-addDevice'].show()
    },
    assignDeviceClick() {
      this.device = {}

      this.device.uid = this.user_id

      try {
        DeviceService.getAll({ status: 'noAssign' }).then(
          res => {
            if (res.status === 'success') {
              if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
                this.freeDevices = res.result.data
              }
            }
          },
        )
      } catch (err) {
        // console.log(err)
      }

      this.$refs['modal-assignDevice'].show()
    },
  },
}
</script>
